import { useStore } from "../zustand/store";
import NoPage from "./404";

const PrivateRoute = ({ children, allowedRoles, apiendpoint, allowedscope, checkscope = false }) => {
  let {  role } = useStore(state => state.userData);

  if (process.env.REACT_APP_APP_MODE === 'live' && role === 'user' && apiendpoint) {
    return (<NoPage />)
  }else 
  if (allowedRoles.includes(role)) {
    return (
      <>{children}</>
    );
  } else {
    return (<NoPage />)
  }
};

export default PrivateRoute;


